import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Splash() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/refer/login");
    }, 3000); // 3 seconds splash duration
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "#f5f5f5",
      }}
    >
      <img
        src="/Logo.png"
        alt="Logo"
        style={{ height: 200, marginBottom: 30 }}
      />
    </div>
  );
}
